import {BaseModel} from "../base";

class AdminShiftPatternModel extends BaseModel {
    constructor(data) {
        if (data.start_time.length == 5) {
            data.start_time = '1970-01-01T' + data.start_time;
        }

        if (data.end_time.length == 5) {
            data.end_time = '1970-01-01T' + data.end_time;
        }

        data.shift_pattern_condition_id = data.shift_pattern_condition_id || null;

        super(data);
    }

    $update(payload) {
        return new Promise((resolve, reject) => {

            if (payload.end_type !== 'count') {
                payload.repeat_count = null;
            }

            // Timepicker converts times to native JS Date
            // We need just time without time zone
            payload.start_time = new Date(payload.start_time).toTimeString().substr(0,5);
            payload.end_time = new Date(payload.end_time).toTimeString().substr(0,5);

            this.$put('self', {}, payload)
                .then((response) => {
                    this.constructor(response);
                    resolve(this);
                })
                .catch(reject);

        });
    }
}

export {
    AdminShiftPatternModel
}
